import {
  ADD_DISCOUNT,
  ADD_DISCOUNT_FULFILLED,
  ADD_DISCOUNT_REJECTED,
  CLEAR_DISCOUNTS,
  CLEAR_DISCOUNTS_FULFILLED,
  CLEAR_DISCOUNTS_REJECTED,
  FETCH_DISCOUNTS,
  FETCH_DISCOUNTS_FULFILLED,
  FETCH_DISCOUNTS_REJECTED,
  REMOVE_DISCOUNT,
  REMOVE_DISCOUNT_FULFILLED,
  REMOVE_DISCOUNT_REJECTED,
  REMOVE_DISCOUNTS,
  REMOVE_DISCOUNTS_FULFILLED,
  REMOVE_DISCOUNTS_REJECTED,
  RESET_DISCOUNTS,
  RESET_REMOVE_DISCOUNTS,
  SUBMIT_DISCOUNTS,
  SUBMIT_DISCOUNTS_FULFILLED,
  SUBMIT_DISCOUNTS_REJECTED,
} from './types';

export function addDiscount(discount) {
  return {
    type: ADD_DISCOUNT,
    payload: { discount },
  };
}

export function addDiscountFulfilled() {
  return {
    type: ADD_DISCOUNT_FULFILLED,
  };
}

export function addDiscountRejected(error) {
  return {
    type: ADD_DISCOUNT_REJECTED,
    payload: { error },
  };
}

export function clearDiscounts() {
  return {
    type: CLEAR_DISCOUNTS,
  };
}

export function clearDiscountsFulfilled() {
  return {
    type: CLEAR_DISCOUNTS_FULFILLED,
  };
}

export function clearDiscountsRejected(error) {
  return {
    type: CLEAR_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function fetchDiscounts() {
  return {
    type: FETCH_DISCOUNTS,
  };
}

export function fetchDiscountsFulfilled(
  availableDiscounts,
  appliedDiscounts,
  discountsNotApplied,
  unavailableDiscounts,
  updatedDiscounts
) {
  return {
    type: FETCH_DISCOUNTS_FULFILLED,
    payload: {
      availableDiscounts,
      appliedDiscounts,
      discountsNotApplied,
      unavailableDiscounts,
      updatedDiscounts,
    },
  };
}

export function fetchDiscountsRejected(error) {
  return {
    type: FETCH_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function removeDiscount(discountId) {
  return {
    type: REMOVE_DISCOUNT,
    payload: { discountId },
  };
}

export function removeDiscountFulfilled() {
  return {
    type: REMOVE_DISCOUNT_FULFILLED,
  };
}

export function removeDiscountRejected(error) {
  return {
    type: REMOVE_DISCOUNT_REJECTED,
    payload: { error },
  };
}

export function removeDiscounts(discountIds) {
  return {
    type: REMOVE_DISCOUNTS,
    payload: { discountIds },
  };
}

export function removeDiscountsFulfilled() {
  return {
    type: REMOVE_DISCOUNTS_FULFILLED,
  };
}

export function removeDiscountsRejected(error) {
  return {
    type: REMOVE_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function resetRemoveDiscounts() {
  return {
    type: RESET_REMOVE_DISCOUNTS,
  };
}

export function resetDiscounts() {
  return {
    type: RESET_DISCOUNTS,
  };
}

export function submitDiscounts() {
  return {
    type: SUBMIT_DISCOUNTS,
  };
}

export function submitDiscountsFulfilled(receiptText) {
  return {
    type: SUBMIT_DISCOUNTS_FULFILLED,
    payload: {
      receiptText,
    },
  };
}

export function submitDiscountsRejected(error) {
  return {
    type: SUBMIT_DISCOUNTS_REJECTED,
    payload: {
      error,
    },
  };
}
